import { render, staticRenderFns } from "./deptType-select.vue?vue&type=template&id=05df8946&scoped=true&"
import script from "./deptType-select.vue?vue&type=script&lang=js&"
export * from "./deptType-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05df8946",
  null
  
)

export default component.exports